import { observable } from 'mobx'
import { ResourcesRequest } from '../ResourcesRequest'
import ResourcesStore from '../ResourcesStore'

class MoveDocumentStore {
  @observable isLoading = false
  @observable parentFolderId = null
  @observable folders = []
  @observable breadCrumb = []

  getListFolder = async (folderId, typeTab) => {
    this.typeTab = typeTab
    this.isLoading = true
    const response = await ResourcesRequest.search({
      id: this.parentFolderId,
      type: 'folder',
      typeTab,
    })
    this.folders = (response.data.data || []).filter(
      item => item.id !== folderId
    )
    this.breadCrumb = response.data?.breadcrumb || []
    this.isLoading = false
  }

  move = async (documentId, folderDestinationId) => {
    this.isLoading = true
    if (folderDestinationId === null) {
      await ResourcesRequest.moveToRoot(documentId)
    } else {
      await ResourcesRequest.move(documentId, folderDestinationId)
    }
    ResourcesStore.search()
    this.isLoading = false
  }

  clearStore = () => {
    this.isLoading = false
    this.folders = []
    this.breadCrumbs = []
    this.parentFolderId = null
    this.typeTab = null
  }
}

export default new MoveDocumentStore()
